export default __webpack_public_path__ + "static/media/shreyas.d6216661.jpeg";